if ($('#player').length && window.innerWidth > 991) {
    initYoutube();
}

function initYoutube() {
    // init YouTube video players
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

window.onYouTubeIframeAPIReady = function () {
    let $element = $('#player');
    let player = new YT.Player('player', {
        height: '',
        width: '',
        videoId: $element.data('youtube-id'),
        playerVars: {
            // 'start': 0,
            // 'end': 0,
            'autoplay': 1,
            'loop': 1,
            'controls': 0,
            'showinfo': 0,
            'modestbranding': 1,
            'rel': 0,
            'iv_load_policy': 3
        },
        events: {
            'onReady': onPlayerReady,
            'onStateChange': onPlayerStateChange
        }
    });

    // sound toggle header video
    var toggle = document.getElementById('toggle-audio');
    if (toggle) {
        toggle.onclick = function (e) {
            e.preventDefault();

            if (player.isMuted()) {
                player.unMute();
            } else {
                player.mute();
            }
        }
    }
}

window.onPlayerReady = function (event) {
    event.target.mute();
}
window.onPlayerStateChange = function (event) {
    event.target.playVideo();
}
